import React from 'react';
import { useState } from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { Button, IconButton, List, ListItem } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
// import { useQuery } from '@tanstack/react-query';
// import { useEffect } from 'react';

// Added Materials to support 2 tier chcklist
import Collapse from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export function FilterSelector(props) {
  const { robotsCalendarArray, calendarRef, filterStates, setFilterStates } = props;
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [expandedFleets, setExpandedFleets] = useState({});

  console.log(`FILTER STATES ${filterStates}`);

  const getCalendarCurrentInstance = () => {
    if (calendarRef.current) return calendarRef.current.getInstance();

    return null;
  };

  const hideCalendar = (index, isChecked) => {
    let calendars = [];
    Object.values(robotsCalendarArray[index][1].calendars).forEach((value) => {
      calendars.push(value);
    });
    getCalendarCurrentInstance()?.setCalendarVisibility(calendars, isChecked);
  };

  const onChange = (isChecked, index) => {
    console.log('CHECK BOX CHANGE');
    let newStates = filterStates.slice();
    newStates[index] = isChecked;
    setFilterStates(newStates);
    hideCalendar(index, isChecked);
    // set calender filter states;
  };

  // To Support 2 tier checklist
  const onFleetChange = (isChecked, robotIndices) => {
    console.log('FLEET CHECK BOX CHANGE');
    let newStates = filterStates.slice();
    robotIndices.forEach((index) => {
      newStates[index] = isChecked;
      hideCalendar(index, isChecked);
    });
    setFilterStates(newStates);
  };

  const toggleFleet = (fleetName) => {
    setExpandedFleets((prev) => ({
      ...prev,
      [fleetName]: !prev[fleetName],
    }));
  };

  const renderList = () => {
    console.log(`IS COLLAPSED ${isCollapsed}`);
    if (isCollapsed) return;

    if (!robotsCalendarArray) return;

    // Group robots by fleet using robotsCalendarArray
    const robotsByFleet = robotsCalendarArray.reduce((acc, [_, robotData], index) => {
      if (!robotData?.ui_fleet_name || !robotData?.ui_robot_name) return acc;

      const fleetName = robotData.ui_fleet_name;
      if (!acc[fleetName]) {
        acc[fleetName] = [];
      }

      acc[fleetName].push({
        name: robotData.ui_robot_name,
        index: index,
        checked: filterStates[index] || false,
      });

      return acc;
    }, {});
    return (
      <FormGroup>
        {Object.entries(robotsByFleet).map(([fleetName, robots]) => {
          const allChecked = robots.every((r) => r.checked);
          const someChecked = robots.some((r) => r.checked);
          const isExpanded = expandedFleets[fleetName] ?? false; // Default expanded

          return (
            <div key={fleetName}>
              {/* Fleet-level checkbox with expand/collapse */}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton size="small" onClick={() => toggleFleet(fleetName)} sx={{ mr: 1 }}>
                  {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                </IconButton>
                <FormControlLabel
                  label={fleetName}
                  control={
                    <Checkbox
                      checked={allChecked}
                      indeterminate={someChecked && !allChecked}
                      onChange={(e) => {
                        const robotIndices = robots.map((r) => r.index);
                        onFleetChange(e.target.checked, robotIndices);
                      }}
                    />
                  }
                />
              </div>

              {/* Robot-level checkboxes (indented, collapsible) */}
              <Collapse in={isExpanded}>
                <FormGroup sx={{ ml: 8 }}>
                  {robots.map((robot) => (
                    <FormControlLabel
                      key={robot.name}
                      label={robot.name}
                      checked={robot.checked}
                      onChange={(e) => onChange(e.target.checked, robot.index)}
                      control={<Checkbox />}
                    />
                  ))}
                </FormGroup>
              </Collapse>
            </div>
          );
        })}
      </FormGroup>
    );
  };

  return (
    <Sidebar collapsed={isCollapsed}>
      <Menu>
        <MenuItem
          onClick={() => setIsCollapsed(!isCollapsed)}
          icon={<MenuOutlinedIcon />}
        ></MenuItem>
      </Menu>
      {renderList()}
    </Sidebar>
  );
}
